@if (loadedError) {
<app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
} @if (!loadedError && loaded && !data) {
<app-widgets-overlay type="no-match"></app-widgets-overlay>
} @if (loaded) {
<div class="widget-container d-flex flex-column">
    <div class="widget-container__object">
        @if (!noTitle) {
        <h1 class="widget-title align-self-center">
            {{ 'web.widget_highest_scoring_half' | translate }}
            ( {{ num }} {{ 'web.matches' | translate }} )
        </h1>
        }
        <div class="d-flex">
            @if (data?.home; as p) {
            <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
                <div class="widget-team__name d-flex align-items-center">
                    <img
                        (error)="imageError($event)"
                        [attr.src]="p.image | responsive : 'participant' : 'medium'"
                        [alt]="p.name"
                        class="img-fluid app-cursor mr-1"
                    />
                    <div>{{ p.name }}</div>
                </div>
            </div>
            } @if (data?.away; as p) {
            <div class="widget-team mt-1 d-flex flex-column widget-team--second" data-cy="team">
                <div class="widget-team__name d-flex align-items-center justify-content-end">
                    <div>{{ p.name }}</div>
                    <img
                        (error)="imageError($event)"
                        [attr.src]="p.image | responsive : 'participant' : 'medium'"
                        [alt]="p.name"
                        class="img-fluid app-cursor ml-1"
                    />
                </div>
            </div>
            }
        </div>
        <div class="m-3">
            @if (sportName) {
            <div class="form-group widget-form">
                <select
                    data-cy="number-of-sets-select"
                    id="number-of-sets-select"
                    [formControl]="typeControl"
                    class="form-control custom-select border-light2"
                >
                    @for (type of periods[sportName] | keys; track $index) {
                    <option [value]="type.key">
                        {{ 'web.' + type.key | translate }}
                    </option>
                    }
                </select>
            </div>
            }
        </div>
        <div class="d-flex flex-column widget-form-participant-container">
            <div class="d-flex justify-content-between">
                <div class=" ">&nbsp;</div>
                <div class="widget-form-participant-text align-self-end">
                    {{ 'web.total_expected_spread' | translate }}
                </div>
                <div class=" ">&nbsp;</div>
            </div>
            <div class="d-flex align-content-stretch widget-form-participant--big">
                <div class="widget-form-participant-bar widget-form-participant-bar--home" [style.width.%]="30">
                    <span class="widget-form-participant-bar--big2" data-cy="avg-home">{{
                        spread('home', type) | number : '1.1-2'
                    }}</span>
                    <br />
                    {{ data?.home?.name }}
                </div>
                <div
                    class="widget-form-participant-bar widget-form-participant-bar--uni widget-form-participant-bar--big text-center"
                    data-cy="avg-total"
                >
                    {{ totalSpread | number : '1.1-2' }}
                </div>
                <div class="widget-form-participant-bar widget-form-participant-bar--away" [style.width.%]="30">
                    <span class="widget-form-participant-bar--big2" data-cy="avg-away">{{
                        spread('away', type) | number : '1.1-2'
                    }}</span>
                    <br />
                    {{ data?.away?.name }}
                </div>
            </div>
        </div>
        <!-- Periods For-->
        <div class="d-flex flex-column widget-form-participant-container mt-4">
            <div class="d-flex justify-content-between">
                <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome">&nbsp;</div>
                <div class="widget-form-participant-text font-weight-bold font-1-1x">
                    {{ 'web.widget_' + sportName + '_points_for' | translate }}
                </div>
                <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway">&nbsp;</div>
            </div>
            <div class="d-flex justify-content-around">
                <app-chart-circle-somple [percentage]="width('home', type, 0)" [text]="data?.home?.name">
                    {{ periodsAvg('home', type)[0] | number : '1.1' }}
                </app-chart-circle-somple>
                <app-chart-circle-somple [percentage]="width('away', type, 0)" [text]="data?.away?.name">
                    {{ periodsAvg('away', type)[0] | number : '1.1' }}
                </app-chart-circle-somple>
            </div>
        </div>
        <!-- Periods Agains-->
        <div class="d-flex flex-column widget-form-participant-container mt-4">
            <div class="d-flex justify-content-between">
                <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome">&nbsp;</div>
                <div class="widget-form-participant-text font-weight-bold font-1-1x">
                    {{ 'web.widget_' + sportName + '_points_agains' | translate }}
                </div>
                <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway">&nbsp;</div>
            </div>
            <div class="d-flex justify-content-around">
                <app-chart-circle-somple [percentage]="width('home', type, 1)" [text]="data?.home?.name">
                    {{ periodsAvg('home', type)[1] | number : '1.1' }}
                </app-chart-circle-somple>
                <app-chart-circle-somple [percentage]="width('away', type, 1)" [text]="data?.away?.name">
                    {{ periodsAvg('away', type)[1] | number : '1.1' }}
                </app-chart-circle-somple>
            </div>
        </div>
        <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
            {{ 'web.num_of_matches' | translate }} ({{ num }})
        </div>
        <div class="widget-logo d-flex justify-content-center mt-4">
            <img
                [src]="'/img/' + client.getName() + '.png'"
                [alt]="client.getName()"
                data-cy="logo"
                class="widget-logo-client"
            />
        </div>
    </div>
</div>
}
